import { cn } from '@/utils/classnames';

type SpinnerProps = {
  width?: number;
  height?: number;
  className?: string;
};

export function Spinner({ width = 24, height = 24, className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn(
        'inline-block shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent',
        className,
      )}
      style={{ width, height }}
    />
  );
}
